import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PosList } from '../../../../core/models/pos.model';

@Injectable({
  providedIn: 'root'
})
export class OrderItemsServiceAdapter {
  constructor(private _httpClient: HttpClient) {}

  public changeQuantity(orderItemId: string, quant: number) {
    return this._httpClient.post<PosList>('api/editrequest', { id: Number(orderItemId), quant });
  }

  public deleteItem(id: string) {
    return this._httpClient.delete<PosList>('api/delete-request/' + id);
  }

  public addItem(newItemPayload: any) {
    return this._httpClient.post<any>('api/add-request', newItemPayload);
  }
}
